import React, { memo } from "react";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import { collectionCols } from "services/stillageCollections";
import { Tooltip } from 'react-tooltip';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { StillageCollectionDataContext } from "context/Context";

const CollectionsTable = ({ loading }) => {
    const { data } = useContext(StillageCollectionDataContext);

    return (
        <AdvanceTableWrapper
            columns={collectionCols}
            data={data?.tableData || []}
            sortable
            perPage={1000}
            pagination={1000}
        >
            <AdvanceTable
                table
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName={({ original: { collectedData, stillageNo } }) => {
                    let className = 'align-middle white-space-nowrap';
                    if (collectedData?.length === stillageNo?.length) className = 'table-success ' + className;
                    if (collectedData?.length > 0 && collectedData?.length != stillageNo?.length) className = 'table-warning ' + className;
                    return className;
                }}
                loading={loading}
                tableProps={{
                    bordered: true,
                    striped: true,
                    className: 'fs--1 mb-0',
                    responsive: true
                }}
                handleClickRow={() => null}
            />
            <Tooltip id="notes-tip" />
            <Tooltip id="stills-tip" />
            <Tooltip id="collected-tip" />
        </AdvanceTableWrapper>
    );
}

CollectionsTable.propTypes = {
    loading: PropTypes.bool,
};

export default memo(CollectionsTable);